import { useCallback } from 'react';
import {
  isOfficeExclusiveDocument,
  useDocumentItems,
  useMediaDelete,
} from '@brightmls/nextgen.lae.mediacenter';

export const useDelete = () => {
  const items = useDocumentItems();
  const { deleteItems, processDelete } = useMediaDelete();

  const deleteOfficeExclusiveDocument = useCallback(async () => {
    const oeDocument = items.find((i) => isOfficeExclusiveDocument(i));

    if (!oeDocument) return;

    await deleteItems([oeDocument.MED_VW_KEY], false);
    await processDelete();
  }, [items]);

  return {
    deleteOfficeExclusiveDocument,
  };
};
